import React, {useEffect} from 'react';
import SubscriptionArrow from '../../assets/icons/SubscriptionArrow';
import { CloseIcon } from '../../assets/icons';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common';

type SubscriptionBannerProps = {
    onClose: () => void;
    message: string;
};



const SubscriptionBanner: React.FC<SubscriptionBannerProps> = ({ onClose, message }: SubscriptionBannerProps) => {

    const navigate = useNavigate()
    const handleNavigate = () => {
        navigate("/Subscription")
    }

    return (
    <>
    <div className='flex md:hidden flex-row md:gap-4  p-4 bg-gray-100 border rounded-lg'>
        <div className="flex items-end justify-start">
               <SubscriptionArrow/>
            </div>  

        
            <div className="flex flex-col">
                <div>
                <h3 className="text-xl font-semibold">Do more with Esemie</h3>
                <p>With just N5,000 you can unlock your business potential.</p> 
                </div>

                <div>
                <Button size='small' variant='primary' onClick={handleNavigate}>Choose a plan</Button>
                </div>
            </div>
          
          <div className='pr-5'>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-800">
                    <CloseIcon/>
            </button>
          </div>
    </div>
    <div className="hidden md:grid grid-cols-4  gap-0 md:gap-4  p-4 bg-gray-100 border rounded-lg xl:mx-[150px] mx-[40px] biglg:mx-[150px]">
            <div className="flex items-center justify-start">
               <SubscriptionArrow/>
            </div>

            <div className="col-span-2 xl:ml-[-6em] biglg:ml-[-6em] lg:ml-[-4em] md:ml-[-3em]">
                <h3 className="text-xl font-semibold">Do more with Esemie</h3>
                <p>With just N5,000 you can unlock your business potential.</p>
            </div>

            <div className="flex items-center justify-between whitespace-nowrap md:ml-[-1em] md:w-[120px] xl:w-[200px] biglg:w-[200px] xl:ml-[-2em] biglg:ml-[-3em] lg:ml-[-1em]">
                <Button size='full' variant='primary' onClick={handleNavigate}>Choose a plan</Button>
                <button onClick={onClose} className="ml-[1em] text-gray-600 hover:text-gray-800">
                    <CloseIcon/>
                </button>
            </div>
        </div>
        
    </>
        
    );
};

export default SubscriptionBanner;

